module.exports = __webpack_public_path__ + "static/media/NejoRampage.ee4874ef.md";